// extracted by mini-css-extract-plugin
export default {"linksWrapper":"WsLinks-module__linksWrapper___Ae10W"};